module.exports = __webpack_public_path__ + "media/images/icons/gakuwari-6461ac3cd3e2a8b8860d4431925781e1.png";